import Vue from "vue";
import App from "./App.vue";
import VueResource from "vue-resource";
import VueRouter from "vue-router";
// @ts-ignore
import Bulma from "bulma";
import Buefy from "buefy";
import { routes } from "./routes/routes.js";
// import VueApexCharts from "vue-apexcharts";
// Vue.use(VueApexCharts);
// Vue.component("apexchart", VueApexCharts);
// import {
//     createTeleInterconsultLog
// } from "./services/teleinterconsult_log";
// import { formatRut } from './services/utils'
// import moment from 'moment'
import { SnackbarProgrammatic as Snackbar } from "buefy";
import "./thirdParty";
import { myMixin } from "./thirdParty/mixin";
import store from "./store/store";
Vue.use(VueRouter);
Vue.use(Bulma);
Vue.use(Buefy, {
    defaultIconPack: "fas",
    defaultContainerElement: "#content",
    defaultProgrammaticPromise: true,
});
Vue.config.productionTip = false;
const enrutador = new VueRouter({
    routes: routes,
    mode: "history",
    linkExactActiveClass: "is-active",
});
enrutador.beforeEach((to, from, next) => {
    let isAuthenticated = window.localStorage.getItem("token") || undefined;
    // if (typeof to.matched[1]?.components.default === 'function') {
    eventBus.$emit("asyncComponentLoading", to); // Start progress bar
    // }
    if (to.name !== "Login" && !isAuthenticated) {
        next({
            name: "Login",
        });
    }
    else {
        next();
    }
});
enrutador.beforeResolve((to, from, next) => {
    eventBus.$emit("asyncComponentLoaded"); // Stop progress bar
    next();
});
// Global error handler for chunk loading failures
enrutador.onError((error) => {
    console.error("Chunk loading error:", error);
    console.error("Chunk loading error fdsuhfhdufhsufh :", error.message);
    // Handle the error gracefully, e.g., show a user-friendly message or retry loading
    const isChunkLoadingError = error.message.includes("Failed to fetch dynamically imported module");
    if (isChunkLoadingError) {
        // You can retry loading the chunk or redirect to an error page
        alert("Failed to load the requested module. Please check your network connection and try again.");
        // Optionally, retry loading the chunk or redirect to a fallback route
        // router.push('/error'); // Redirect to an error page
    }
});
export const eventBus = new Vue();
Vue.use(VueResource);
const url = window.location.hostname;
const urlSplitted = url.split("");
if (urlSplitted[urlSplitted.length - 1] == "w") {
    Vue.http.options.root = process.env.VUE_APP_API_URL_LOCAL;
}
else if (urlSplitted[urlSplitted.length - 1] == "m") {
    Vue.http.options.root = process.env.VUE_APP_API_URL_SSM;
}
else {
    Vue.http.options.root = process.env.VUE_APP_API_URL;
}
Vue.http.interceptors.push((request, next) => {
    var token = window.localStorage.getItem("token") || undefined;
    if (token) {
        request.headers.set("Authorization", "Bearer" + token);
        request.headers.set("Accept", "application/json");
    }
    next((response) => {
        if (response.status === 0) {
            // enrutador.push("/");
        }
        else if (response.status === 500) {
            //  enrutador.push('/')
        }
        else if (response.status === 401) {
            eventBus.$emit("value", true);
        }
    });
});
const appVersion = process.env.VUE_APP_GLOBAL_VERSION;
const browserVersion = window.localStorage.getItem("appVersion");
if (appVersion !== browserVersion) {
    window.localStorage.setItem("appVersion", appVersion || "No version");
    window.location.reload();
}
Vue.config.productionTip = false;
Vue.mixin(myMixin);
if (process.env.VUE_APP_API_URL == "https://telemedicaldev-api.dssmag.cl" && url[url.length - 1] != "w") {
    Snackbar.open({
        message: `Este es un ambiente de <b>DESARROLLO</b>`,
        type: "is-warning",
        position: "is-bottom-right",
        actionText: "cerrar",
        indefinite: true,
    });
}
if (process.env.VUE_APP_API_URL == "https://telemedicalpre-api.dssmag.cl" && url[url.length - 1] != "w") {
    Snackbar.open({
        message: `Este es un ambiente de <b>PREPRODUCCIÓN</b>`,
        type: "is-warning",
        position: "is-bottom-right",
        actionText: "cerrar",
        indefinite: true,
    });
}
// Vue.config.errorHandler = (err, vm, info) => {
//   console.error(err);
// if (JSON.parse(window.localStorage.getItem("user"))?.id) {
//   ErrorLogService.create({
//     id: 0,
//     user_id: JSON.parse(window.localStorage.getItem("user"))?.id,
//     role_id: Number(window.localStorage.getItem("role_id")),
//     node_id: Number(window.localStorage.getItem("stablishment")),
//     error_message: err.stack,
//     error_title: err.message,
//     url: window.location.href,
//     browser: navigator.userAgent,
//     error_type: info,
//   });
// }
// };
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyB9aaYk5mfMTnoaWWEZkRvvce-UJpptRLk",
// libraries: "places, drawing, visualization", // This is required if you use the Autocomplete plugin
// OR: libraries: 'places,drawing'
// OR: libraries: 'places,drawing,visualization'
// (as you require)
//// If you want to set the version, you can do so:
// v: '3.26',
// },
//// If you intend to programmatically custom event listener code
//// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
//// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
//// you might need to turn this on.
// autobindAllEvents: false,
//// If you want to manually install components, e.g.
//// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
//// Vue.component('GmapMarker', GmapMarker)
//// then set installComponents to 'false'.
//// If you want to automatically install all the components this property must be set to 'true':
//   installComponents: true,
// });
// main.ts
function getApiUrlEntity(entity) {
    if (process.env.VUE_APP_SHOW_ENTITY === "true") {
        return `${entity}/`;
    }
    return "";
}
// Attach the function to the window object
window.getApiUrlEntity = getApiUrlEntity;
new Vue({
    router: enrutador,
    render: (h) => h(App),
    store: store,
}).$mount("#app");
